import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var InsiderBenefitsOverviewItem = function(param) {
    var icon = param.icon, title = param.title, description = param.description;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            icon,
            /*#__PURE__*/ _jsxs(Column, {
                gap: 8,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "sectionHeaderSansMedium",
                            tabletAndAbove: "subheadingSansMedium",
                            desktopAndAbove: "sectionHeaderSansMedium"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "subheadingSansRegular",
                            tabletAndAbove: "paragraphSansRegular"
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
var Wrapper = styled(Flex).attrs({
    gap: 14,
    direction: {
        mobileAndAbove: "column",
        desktopAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-4e0de5-0"
})([
    "",
    "{max-width:268px;flex:1;}",
    "{max-width:304px;svg{margin:",
    ";}}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove, getSpacing(4, 0, 0, 0));
